module.exports = __webpack_public_path__ + "static/media/icon-mediana.6d74a737.svg";